export const carouselItems = [
  {
    id: 1,
    title: '娱乐圈年度大瓜盘点：那些年我们追过的内幕爆料',
    summary: '从顶流塌房到资本暗战，2024年娱乐圈真实内幕全景回顾，吃瓜群众不可错过的经典瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20entertainment%20news%20spotlight%20on%20red%20carpet%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20gold%20tones%2C%20stylized%20magazine%20cover%20aesthetic%2C%20clean%20minimal%20background%20with%20soft%20texture%2C%20artistic%20conceptual%20design%20for%20gossip%20media%20platform&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    date: '2025-07-28',
    views: '128.6万',
  },
  {
    id: 2,
    title: '某当红小生深夜密会引热议，知情人独家爆料背后真相',
    summary: '连续三天被拍到出入同一小区，圈内好友爆料两人已秘恋半年，更多细节持续曝光。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20night%20cityscape%20with%20warm%20street%20lights%20and%20silhouetted%20figures%2C%20mysterious%20atmosphere%2C%20paparazzi%20aesthetic%2C%20golden%20and%20deep%20red%20accents%2C%20editorial%20photography%20style%2C%20clean%20dark%20background%20with%20soft%20bokeh%20lights&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '独家爆料',
    date: '2025-07-28',
    views: '96.3万',
  },
  {
    id: 3,
    title: '综艺节目录制现场突发状况，嘉宾当场翻脸真实原因揭秘',
    summary: '节目组内部工作人员匿名投稿，还原当天录制全过程的真实细节，剧本还是意外一目了然。',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20stage%20lighting%20in%20warm%20amber%20and%20red%20tones%2C%20spotlight%20effect%2C%20theatrical%20atmosphere%2C%20entertainment%20show%20production%20aesthetic%2C%20clean%20composition%20with%20dark%20background%2C%20editorial%20style&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '综艺内幕',
    date: '2025-07-27',
    views: '87.1万',
  },
  {
    id: 4,
    title: '品牌代言突然换人：资本博弈背后的明星站队与利益分配',
    summary: '某国际品牌一夜之间更换亚太区代言人，深入扒出品牌方与经纪公司之间的暗流涌动。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20billboard%20in%20city%20center%20at%20dusk%2C%20warm%20golden%20light%2C%20fashion%20commercial%20aesthetic%2C%20editorial%20photography%2C%20sophisticated%20urban%20scene%2C%20clean%20background%20with%20soft%20evening%20glow%2C%20minimal%20composition&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '商业内幕',
    date: '2025-07-27',
    views: '73.5万',
  },
  {
    id: 5,
    title: '网剧爆红背后：小成本制作如何逆袭成为现象级话题',
    summary: '从无人问津到全网刷屏，一部网剧的逆袭之路揭示了影视行业哪些不为人知的运作规则。',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20camera%20equipment%20and%20warm%20cinematic%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20indie%20film%20production%20aesthetic%2C%20golden%20hour%20tones%2C%20artistic%20composition%2C%20clean%20minimal%20background%2C%20editorial%20photography%20style&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '影视深扒',
    date: '2025-07-26',
    views: '65.8万',
  },
  {
    id: 6,
    title: '音乐节后台独家直击：顶流歌手与主办方的合约纠纷始末',
    summary: '连演三场临时取消两场，知情人提供的合同细节揭示行业内常见的霸王条款与利益纠葛。',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20stage%20with%20colorful%20concert%20lights%20and%20crowd%20silhouettes%2C%20energetic%20atmosphere%2C%20warm%20coral%20and%20gold%20spotlights%2C%20live%20performance%20aesthetic%2C%20editorial%20style%2C%20clean%20dark%20background%20with%20dramatic%20lighting%20effects&width=800&height=450&seq=carousel-06&orientation=landscape',
    tag: '演出风波',
    date: '2025-07-26',
    views: '58.2万',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '真实爆料审核',
    description: '每条爆料经过多源交叉验证，确保吃瓜内容真实可信，拒绝虚假信息传播。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '实时追踪更新',
    description: '热点事件第一时间跟进，持续追踪事件进展，让你永远走在吃瓜第一线。',
  },
  {
    id: 3,
    icon: 'ri-eye-off-line',
    title: '匿名投稿保护',
    description: '严格保护爆料人隐私信息，多重加密技术确保投稿者身份安全无忧。',
  },
  {
    id: 4,
    icon: 'ri-group-line',
    title: '瓜友社区互动',
    description: '百万真实用户共同讨论，理性吃瓜文明交流，打造最有温度的娱乐资讯社区。',
  },
  {
    id: 5,
    icon: 'ri-vip-crown-line',
    title: '独家深度内容',
    description: '专业编辑团队深度挖掘，提供你看不到的幕后故事与行业真相分析。',
  },
];

export const cards = [
  {
    id: 1,
    title: '某女星婚变内幕全解析：三年婚姻走到尽头的真实原因',
    summary: '从恩爱夫妻到对簿公堂，这桩娱乐圈最受关注的离婚案背后，隐藏着远比表面更复杂的故事。多方信源交叉印证，还原婚姻破裂全过程。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20ring%20on%20surface%20with%20soft%20dramatic%20lighting%2C%20emotional%20editorial%20photography%2C%20warm%20coral%20and%20rose%20gold%20tones%2C%20minimal%20composition%2C%20melancholy%20aesthetic%2C%20clean%20background%20with%20gentle%20shadows&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '明星婚变',
    date: '2025-07-28',
    views: '156.3万',
  },
  {
    id: 2,
    title: '选秀节目黑幕大起底：导师评分背后的资本运作逻辑',
    summary: '多位参赛选手联合发声，揭露选秀节目中不为人知的评分操纵机制与利益分配内幕，引发行业震动。',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20judges%20panel%20and%20dramatic%20spotlight%2C%20theatrical%20atmosphere%2C%20warm%20amber%20and%20gold%20stage%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20clean%20dark%20background%2C%20editorial%20style&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '选秀黑幕',
    date: '2025-07-27',
    views: '132.7万',
  },
  {
    id: 3,
    title: '顶流网红翻车事件完整时间线：从神坛跌落的72小时',
    summary: '一场直播引发的连锁反应，站内独家梳理事件全貌，包含当事人未公开的私下回应与品牌方紧急应对策略。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20feed%20with%20dramatic%20red%20notification%20alerts%2C%20digital%20crisis%20aesthetic%2C%20warm%20screen%20glow%20in%20dark%20setting%2C%20modern%20editorial%20photography%2C%20clean%20composition&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '网红翻车',
    date: '2025-07-27',
    views: '118.9万',
  },
  {
    id: 4,
    title: '影视圈阴阳合同再起波澜：某大导新片投资方真实身份曝光',
    summary: '一份意外流出的内部文件，牵出影视投资领域不为人知的资本链条与避税操作新花样。',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20contracts%20and%20documents%20on%20wooden%20desk%20with%20warm%20desk%20lamp%20lighting%2C%20legal%20drama%20aesthetic%2C%20golden%20amber%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20clean%20minimal%20background&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '合同内幕',
    date: '2025-07-26',
    views: '95.4万',
  },
  {
    id: 5,
    title: '某知名主持人被曝私生活混乱，多年正面人设一夜崩塌',
    summary: '站内收到多份来自不同信源的实名投稿，揭示这位被观众称为国民导师的主持人不为人知的另一面。',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20microphone%20on%20empty%20stage%20with%20dramatic%20single%20spotlight%2C%20broadcasting%20aesthetic%2C%20warm%20coral%20and%20deep%20shadow%20contrast%2C%20editorial%20photography%2C%20atmospheric%20composition%2C%20clean%20dark%20background&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '人设崩塌',
    date: '2025-07-26',
    views: '89.1万',
  },
  {
    id: 6,
    title: '娱乐圈资本局：某影视公司对赌失败后的资产腾挪术',
    summary: '深度调查某知名影视公司如何在业绩对赌失败后，通过复杂的股权操作和关联交易规避巨额赔偿。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20glass%20facade%20reflecting%20sunset%20sky%2C%20corporate%20financial%20aesthetic%2C%20warm%20golden%20hour%20light%2C%20professional%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20urban%20architecture&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '资本暗战',
    date: '2025-07-25',
    views: '76.8万',
  },
  {
    id: 7,
    title: '流量明星数据造假产业链全揭秘：从刷量到控评的灰色地带',
    summary: '深入调查流量经济背后的数据工厂，揭示一条年产值数十亿的灰色产业链的完整运作模式。',
    image: 'https://readdy.ai/api/search-image?query=Server%20room%20with%20blinking%20lights%20and%20data%20cables%2C%20cyber%20aesthetic%2C%20warm%20amber%20indicator%20lights%20in%20dark%20setting%2C%20technology%20investigation%20theme%2C%20editorial%20photography%2C%20clean%20composition%20with%20dramatic%20lighting&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '数据造假',
    date: '2025-07-25',
    views: '68.3万',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '某顶流歌手税务问题持续发酵，工作室紧急声明却被网友逐条打脸', hot: '236.8万', trend: 'up', tag: '爆' },
  { id: 2, rank: 2, title: '大热综艺录制现场导演与嘉宾激烈争吵，视频片段网络疯传', hot: '198.5万', trend: 'up', tag: '热' },
  { id: 3, rank: 3, title: '知名导演新片选角内定传闻，多位一线演员经纪人私下抱怨', hot: '175.2万', trend: 'up', tag: '热' },
  { id: 4, rank: 4, title: '某女团成员退团真相：经纪公司压榨合同细节首次完整公开', hot: '142.6万', trend: 'new', tag: '新' },
  { id: 5, rank: 5, title: '网红直播带货翻车，品牌方连夜发律师函要求赔偿千万', hot: '98.3万', trend: 'up', tag: '热' },
  { id: 6, rank: 6, title: '某影视奖项评选被曝评委内定，多位获奖者履历遭网友深扒', hot: '87.9万', trend: 'new', tag: '新' },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20person%20with%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我追了三天了！站内的爆料速度确实快，比其他平台早了半天就出了完整时间线。而且每一条都有信源标注，这点真的很加分，不是那种看图说话的无脑搬运。',
    likes: 3821,
    tag: '铁杆瓜友',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20confident%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐观察家',
    time: '5小时前',
    content: '关注吃瓜爆料半年了，最大的感受就是这里的信息质量在同类平台里算上乘的。不会为了流量乱写标题党，内容有深度有分析，真的能了解到行业内部的运作逻辑。',
    likes: 2654,
    tag: '资深瓜友',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '真相挖掘机',
    time: '8小时前',
    content: '之前在其他平台看到的爆料好多都是假的，来这边之后发现每条都有交叉验证，而且投稿人隐私保护做得很好，大家才敢说真话。这才是吃瓜的正确打开方式！',
    likes: 1893,
    tag: '新晋瓜友',
  },
];

export const topics = [
  { id: 1, name: '顶流塌房', count: '568万', icon: 'ri-alert-line' },
  { id: 2, name: '明星婚变', count: '423万', icon: 'ri-emotion-sad-line' },
  { id: 3, name: '综艺黑幕', count: '389万', icon: 'ri-tv-line' },
  { id: 4, name: '网红翻车', count: '356万', icon: 'ri-arrow-go-back-line' },
  { id: 5, name: '选秀内定', count: '312万', icon: 'ri-star-line' },
  { id: 6, name: '资本暗战', count: '287万', icon: 'ri-funds-line' },
  { id: 7, name: '数据造假', count: '254万', icon: 'ri-bar-chart-line' },
  { id: 8, name: '合约纠纷', count: '231万', icon: 'ri-file-text-line' },
  { id: 9, name: '私生活曝光', count: '208万', icon: 'ri-camera-line' },
];

export const faqItems = [
  {
    id: 1,
    question: '吃瓜爆料的资讯来源可靠吗？',
    answer: '每条爆料均经过多源交叉验证机制审核，标注信息来源与可信度等级。站内设有专业编辑团队，对投稿内容进行事实核查后方可发布，确保吃瓜内容的真实性与准确性。',
  },
  {
    id: 2,
    question: '如何向吃瓜爆料投稿？',
    answer: '可通过本站投稿入口提交爆料内容，支持文字、图片和文件上传。我们采用多重加密技术严格保护投稿者隐私，所有投稿信息仅用于内容核实，不会对外泄露投稿人身份。',
  },
  {
    id: 3,
    question: '吃瓜爆料的内容更新频率如何？',
    answer: '实行全天候实时更新机制，热点事件发生后15分钟内即可上线首条快讯。每日平均更新爆料内容超过50条，重大事件设有专题追踪页面，确保你不遗漏任何关键进展。',
  },
  {
    id: 4,
    question: '吃瓜爆料的内容是否收费？',
    answer: '所有资讯内容完全免费开放阅读，不设置付费墙或会员专属内容。我们的核心理念是让每一位吃瓜群众都能平等地获取真实、及时的娱乐资讯和行业内幕信息。',
  },
  {
    id: 5,
    question: '发现不实信息如何处理？',
    answer: '如对站内内容真实性有疑问，可通过纠错反馈渠道提交异议。我们承诺在收到反馈后4小时内启动复核程序，确认为不实信息的内容将立即标注或下架，并公开更正说明。',
  },
  {
    id: 6,
    question: '吃瓜爆料与其他娱乐资讯平台有什么不同？',
    answer: '区别于标题党和碎片化搬运，我们坚持深度内容原创、多角度分析和信源可追溯三大原则。不追求单纯流量，而是致力于打造真正有信息价值的娱乐资讯社区。',
  },
];

export const updates = [
  { id: 1, time: '10分钟前', content: '某选秀节目导师被曝收受选手贿赂，节目组紧急回应称将配合调查', badge: '突发' },
  { id: 2, time: '28分钟前', content: '知名编剧微博深夜发文暗示将爆料某导演潜规则内幕，评论区已炸锅', badge: '追踪' },
  { id: 3, time: '1小时前', content: '某品牌官宣新代言人引发粉丝大战，前任代言人粉丝集体抵制', badge: '热议' },
  { id: 4, time: '2小时前', content: '影视公司财报揭露艺人薪酬占比，某一线明星年收入超公司净利润', badge: '深扒' },
  { id: 5, time: '3小时前', content: '音乐平台被曝数据造假，某歌手新歌播放量一夜暴涨三千万引质疑', badge: '独家' },
  { id: 6, time: '4小时前', content: '综艺录制现场观众爆料：某女星全程黑脸拒绝配合，导演组临时改流程', badge: '爆料' },
  { id: 7, time: '5小时前', content: '某影视奖项入围名单遭提前泄露，多位入围者工作室表示不知情', badge: '追踪' },
  { id: 8, time: '6小时前', content: '知名网红被品牌方集体解约，知情人士透露与其私下不当言论有关', badge: '独家' },
];

export const indexItems = [
  { id: 1, title: '明星恋情追踪', count: '326篇', desc: '最新明星恋情、婚姻、分手动态实时追踪', icon: 'ri-heart-line' },
  { id: 2, title: '综艺节目内幕', count: '258篇', desc: '热门综艺背后的剧本安排与真实关系揭秘', icon: 'ri-tv-2-line' },
  { id: 3, title: '影视行业深扒', count: '219篇', desc: '电影电视剧投资、选角、片酬行业内幕分析', icon: 'ri-film-line' },
  { id: 4, title: '网红圈风云', count: '187篇', desc: '直播带货、短视频达人、MCN机构内幕揭秘', icon: 'ri-live-line' },
  { id: 5, title: '品牌代言博弈', count: '165篇', desc: '明星代言背后的商业逻辑与利益分配解析', icon: 'ri-building-line' },
  { id: 6, title: '音乐圈爆料', count: '142篇', desc: '歌手合约纠纷、演唱会内幕、音乐榜单真相', icon: 'ri-music-line' },
  { id: 7, title: '时尚圈秘辛', count: '128篇', desc: '时装周潜规则、超模圈内幕、品牌合作暗战', icon: 'ri-t-shirt-line' },
  { id: 8, title: '饭圈文化观察', count: '113篇', desc: '粉丝经济现象、应援文化分析、饭圈动态追踪', icon: 'ri-user-heart-line' },
];

export const mediaItems = [
  {
    id: 1,
    title: '独家深度：2024娱乐圈大事件全景回顾',
    duration: '45:28',
    image: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20play%20button%20overlay%2C%20entertainment%20news%20collage%20with%20warm%20coral%20and%20amber%20tones%2C%20dramatic%20lighting%2C%20modern%20editorial%20design%2C%20clean%20composition%20with%20dark%20background%20and%20accent%20color%20highlights&width=640&height=360&seq=media-01&orientation=landscape',
    views: '89.6万',
    tag: '年度盘点',
  },
  {
    id: 2,
    title: '瓜友圆桌：聊聊最近那些让人意外的反转瓜',
    duration: '32:15',
    image: 'https://readdy.ai/api/search-image?query=Podcast%20studio%20with%20warm%20ambient%20lighting%20and%20microphones%2C%20talk%20show%20aesthetic%2C%20golden%20and%20coral%20tones%2C%20cozy%20professional%20atmosphere%2C%20editorial%20photography%2C%20clean%20minimal%20background%20with%20soft%20shadows&width=640&height=360&seq=media-02&orientation=landscape',
    views: '56.3万',
    tag: '圆桌讨论',
  },
  {
    id: 3,
    title: '内幕揭秘：流量明星数据造假的完整产业链',
    duration: '28:42',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20documentary%20thumbnail%20with%20magnifying%20glass%20over%20data%20charts%2C%20warm%20amber%20and%20red%20accent%20tones%2C%20mysterious%20noir%20aesthetic%2C%20professional%20editorial%20design%2C%20clean%20dark%20background%20with%20dramatic%20contrast&width=640&height=360&seq=media-03&orientation=landscape',
    views: '42.7万',
    tag: '调查报道',
  },
];

export const siteStats = {
  totalArticles: '15,800+',
  dailyUpdates: '50+',
  activeUsers: '280万+',
};